<template>
  <div class="wrapper home-page">
    <div class="home-page-top">
      <div class="left">
        <el-button :disabled="!common.canEdit()" type="primary" class="import-btn" @click="importClick">导入数据
        </el-button>
        <el-button :disabled="!common.canEdit()" type="primary" class="import-btn" @click="addClick">添加提货单
        </el-button>
        <el-button :disabled="!common.canEdit()" type="success" class="import-btn" @click="vdsSyncClick">VDS单据同步
        </el-button>
      </div>
      <div class="right">
        <el-input class="search-input" placeholder="请输入关键字模糊搜索" v-model="searchInput" @input="searchChange">
          <el-button type="primary" slot="append" icon="el-icon-search" @click="search()"></el-button>
        </el-input>
        <el-button type="primary" v-if="activeName != -1" @click="exportExcel" class="export-btn">导出Excel表格
        </el-button>
      </div>
      <div class="choice" v-if="activeName == 1">
        <!-- 				<el-checkbox class="choice-all" border :indeterminate="isIndeterminateFreight" v-model="checkAllFreight" @change="FreightCheckAllChange">全选</el-checkbox>
 -->
        <el-checkbox-group v-model="checkedFreight" @change="CheckedFreightChange">
          <el-checkbox-button v-for="item in freightList" :label="item" :key="item">{{ item }}
          </el-checkbox-button>
        </el-checkbox-group>
      </div>
    </div>
    <!-- 切换按钮 -->
    <el-tabs class="main-tabs" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane v-if="common.canEdit()" label="未编辑" name="-1">
        <editTable :searchInput="searchValue" :refresh="refresh"></editTable>
      </el-tab-pane>
      <el-tab-pane label="待审核" name="1">
        <pendingReview :searchInput="searchValue" :isFree="isFree" :refresh="refresh"
                       @sparePartsType="sparePartsTypes">
        </pendingReview>
      </el-tab-pane>
      <el-tab-pane label="已通过" name="2">
        <passTable :searchInput="searchValue" :refresh="refresh" @appendTracking="appendTracking"></passTable>
      </el-tab-pane>
      <el-tab-pane label="未通过" name="3">
				<span slot="label">
					<el-badge :value="noPassTotal" class="item">
						未通过
					</el-badge>
				</span>
        <notPassTable :searchInput="searchValue" @total="getTotal" :refresh="refresh" @appendTracking="appendTracking">
        </notPassTable>
      </el-tab-pane>
      <el-tab-pane label="全部" name="0">
        <allTable :refresh="refresh" :searchInput="searchValue" :loading="loading"></allTable>
      </el-tab-pane>
    </el-tabs>
    <!-- 导入弹窗 -->
    <el-dialog title="导入数据" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="导入日期" required>
          <el-form-item prop="date">
            <el-date-picker type="date" placeholder="请选择导入日期" v-model="ruleForm.date" format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd" style="width: 100%;">
            </el-date-picker>
          </el-form-item>
        </el-form-item>
        <el-form-item label="导入数据" prop="fileList">
          <el-upload class="upload-demo" action="/api/admin/invoice/upload" ref="upload" :headers="headers"
                     :auto-upload="false" accept=".xlsx, .xls" multiple :data="{ entryDate: ruleForm.date }"
                     :on-change="fileChange" :on-remove="fileRemove" :on-success="handleSuccess"
                     :file-list="ruleForm.fileList" v-model="ruleForm.fileList">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传xls/xlsx格式文件</div>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
          <el-button @click="dialogFormVisible = false">取 消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 导出弹窗 -->
    <el-dialog title="导出数据" :visible.sync="dialogExportVisible" :close-on-click-modal="false">
      <el-form ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="选择日期范围">
          <el-date-picker v-model="dateRange" type="datetimerange" range-separator="至"
                          start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="选择导出列" prop="fileList">
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选
          </el-checkbox>
          <el-checkbox-group v-model="checkedHeaders" @change="handleCheckedCitiesChange">
            <el-checkbox v-for="item in tHeaderBox" :label="item.key" :key="item.key">{{ item.lable }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="downloadLoading" @click="handleDownload">下载</el-button>
          <el-button @click="dialogExportVisible = false">取 消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 添加提货单 -->
    <el-dialog title="添加提货单" :visible.sync="dialogAddVisible" width="70%" v-if="dialogAddVisible"
               :close-on-click-modal="false">
      <el-form :model="addRuleForm" :rules="addRules" ref="addRuleForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="提货通知单:" required>
          <el-col :span="12">
            <el-form-item prop="deliveryNotice">
              <el-input v-model="addRuleForm.deliveryNotice"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="录入日期:" required>
              <el-form-item prop="entryDate">
                <el-date-picker type="date" placeholder="选择录入日期" v-model="addRuleForm.entryDate">
                </el-date-picker>
              </el-form-item>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="提货单编号:" required>
          <el-col :span="12">
            <el-form-item prop="orderNum">
              <el-input v-model="addRuleForm.orderNum"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="单位简称:" prop="unitName">
              <el-input v-model="addRuleForm.unitName"></el-input>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="提货金额(元):" required>
          <el-col :span="12">
            <el-form-item prop="totalAmount">
              <el-input v-model.number="addRuleForm.totalAmount" type="number"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="提货件数:" prop="totalNum">
              <el-input-number v-model="addRuleForm.totalNum"></el-input-number>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="提货明细:">
          <el-button type="primary" size="small" @click="detailsAdd">添加</el-button>
          <el-button :disabled="!common.canEdit()" size="small" type="primary" class="import-btn" @click="importClickDetail">导入数据
          </el-button>
          <el-table class="main-table" :data="addRuleForm.invoiceDetails" border
                    header-row-class-name="table-header mini-table-header" highlight-current-row>
            <el-table-column prop="sparePartCode" label="备件代码">
              <template slot-scope="scope">
                <el-form-item :prop="`invoiceDetails.${scope.$index}.sparePartCode`"
                              :rules="addRules.nonull">
                  <el-input v-model="scope.row.sparePartCode" placeholder="请输入"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="sparePartName" label="备件名称">
              <template slot-scope="scope">
                <el-form-item :prop="`invoiceDetails.${scope.$index}.sparePartName`"
                              :rules="addRules.nonull">
                  <el-input v-model="scope.row.sparePartName" placeholder="请输入"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="num" label="数量">
              <template slot-scope="scope">
                <el-form-item :prop="`invoiceDetails.${scope.$index}.num`" :rules="addRules.nonull">
                  <el-input-number v-model="scope.row.num"></el-input-number>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="costPrice" label="单价">
              <template slot-scope="scope">
                <el-form-item :prop="`invoiceDetails.${scope.$index}.costPrice`"
                              :rules="addRules.nonull">
                  <el-input v-model="scope.row.costPrice" placeholder="请输入" type="number"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="amount" label="金额">
              <template slot-scope="scope">
                <el-form-item :prop="`invoiceDetails.${scope.$index}.amount`" :rules="addRules.nonull">
                  <el-input v-model="scope.row.amount" placeholder="请输入" type="number"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="80px" align="center">
              <template slot-scope="scope">

                <el-button type="warning" size="small" @click="detailsDel(scope.row,scope.$index)">删除
                </el-button>
              </template>
            </el-table-column>

          </el-table>

        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addSubmitForm('addRuleForm')">提交</el-button>
          <el-button @click="dialogAddVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="导入明细" :visible.sync="dialogFormVisibleDetail" :close-on-click-modal="false">
      <el-form :model="ruleFormDetail" :rules="rulesDetail" ref="ruleFormDetail" label-width="100px" class="demo-ruleForm">
        <el-form-item label="明细文件" prop="fileList">
          <el-upload class="upload-demo" action="/api/admin/invoice/uploadDetail" ref="uploadDetail" :headers="headers"
                     :auto-upload="false" accept=".xlsx, .xls" multiple  :data="{ entryDate: ruleForm.date }"
                     :on-change="fileChangeDetail" :on-remove="fileRemoveDetail" :on-success="handleSuccessDetail"
                     :file-list="ruleFormDetail.fileList" v-model="ruleFormDetail.fileList">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传xls/xlsx格式文件</div>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitFormDetail('ruleFormDetail')">确 定</el-button>
          <el-button @click="dialogFormVisibleDetail = false">取 消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- VDS登录弹窗 -->
    <el-dialog title="VDS单据同步(请输入VDS系统有效的用户名和密码，单次仅供查询1000条数据)" :visible.sync="vdsDialogVisible" width="80%" :close-on-click-modal="false" custom-class="vds-sync-dialog">
      <!-- 登录表单 -->
      <div v-if="!vdsIsLoggedIn">
        <el-form :model="vdsLoginForm" :rules="vdsLoginRules" ref="vdsLoginForm" label-width="100px" class="demo-ruleForm" autocomplete="off">
          <el-form-item label="用户名" prop="loginName">
            <el-input v-model="vdsLoginForm.loginName" placeholder="请输入用户名" autocomplete="off" name="vds_username"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input v-model="vdsLoginForm.password" type="password" placeholder="请输入密码" @keyup.enter.native="vdsHandleLogin" autocomplete="new-password" name="vds_password"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="vdsHandleLogin" :loading="vdsLoginLoading">登录</el-button>
            <el-button @click="vdsDialogVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 销售出库单查询 -->
      <div v-else>
        <div class="vds-search-form">
          <el-form :inline="true" :model="vdsQueryParam" class="demo-form-inline">
            <el-form-item label="单据编号">
              <el-input v-model="vdsQueryParam.number" placeholder="请输入单据编号" clearable></el-input>
            </el-form-item>
            <el-form-item label="商品信息">
              <el-input v-model="vdsQueryParam.materialParam" placeholder="请输入商品信息" clearable></el-input>
            </el-form-item>
            <el-form-item label="单据日期">
              <el-date-picker
                v-model="vdsQueryParam.createTimeRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="vdsOnDateChange"
              ></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="vdsSearchSaleOut" :loading="vdsSearchLoading">查询</el-button>
              <el-button @click="vdsResetSearch">重置</el-button>
              <el-button type="text" @click="vdsToggleSearch">
                {{ vdsToggleSearchStatus ? '收起' : '展开' }}
                <i :class="vdsToggleSearchStatus ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
              </el-button>
            </el-form-item>
          </el-form>
          <template v-if="vdsToggleSearchStatus">
            <el-form :inline="true" :model="vdsQueryParam" class="demo-form-inline" style="margin-top: 10px;">
              <el-form-item label="客户">
                <el-input v-model="vdsQueryParam.customerName" placeholder="请选择客户">
                  <i v-if="vdsQueryParam.customerName" slot="suffix" class="el-input__icon el-icon-circle-close" @click="vdsOnClearCustomer" style="cursor: pointer;"></i>
                  <i v-else slot="suffix" class="el-input__icon el-icon-search" @click="vdsOnSearchCustomer" style="cursor: pointer;"></i>
                </el-input>
              </el-form-item>
              <el-form-item label="仓库名称">
                <el-select v-model="vdsQueryParam.depotId" placeholder="请选择仓库" clearable style="width: 150px;" filterable>
                  <el-option v-for="depot in vdsDepotList" :key="depot.id" :value="depot.id" :label="depot.depotName"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="操作员">
                <el-select v-model="vdsQueryParam.creator" placeholder="选择操作员" clearable style="width: 150px;" filterable>
                  <el-option v-for="user in vdsUserList" :key="user.id" :value="user.id" :label="user.userName"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="关联订单">
                <el-input v-model="vdsQueryParam.linkNumber" placeholder="请输入关联订单" clearable></el-input>
              </el-form-item>
            </el-form>
            <el-form :inline="true" :model="vdsQueryParam" class="demo-form-inline" style="margin-top: 10px;">
              <el-form-item label="结算账户">
                <el-select v-model="vdsQueryParam.accountId" placeholder="选择结算账户" clearable style="width: 150px;" filterable>
                  <el-option v-for="account in vdsAccountList" :key="account.id" :value="account.id" :label="account.name"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="有无欠款">
                <el-select v-model="vdsQueryParam.hasDebt" placeholder="选择欠款状态" clearable style="width: 120px;">
                  <el-option value="1" :label="'有欠款'">有欠款</el-option>
                  <el-option value="0" :label="'无欠款'">无欠款</el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="单据状态">
                <el-select v-model="vdsQueryParam.status" placeholder="选择单据状态" clearable style="width: 120px;">
                  <el-option value="0" :label="'未审核'">未审核</el-option>
                  <el-option value="1" :label="'已审核'">已审核</el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="单据备注">
                <el-input v-model="vdsQueryParam.remark" placeholder="请输入单据备注" clearable></el-input>
              </el-form-item>
            </el-form>
            <el-form :inline="true" :model="vdsQueryParam" class="demo-form-inline" style="margin-top: 10px;">
              <el-form-item label="销售人员">
                <el-select v-model="vdsQueryParam.salesMan" placeholder="请选择销售人员" clearable style="width: 150px;" filterable>
                  <el-option v-for="salesMan in vdsSalesManList" :key="salesMan.value" :value="salesMan.value" :label="salesMan.text"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="合同代码">
                <el-input v-model="vdsQueryParam.contractCode" placeholder="请输入合同代码" clearable></el-input>
              </el-form-item>
              <el-form-item label="欠款天数">
                <el-input-number v-model="vdsQueryParam.debtDaysMin" :min="0" placeholder="最小" style="width: 130px;"></el-input-number>
                <span style="margin: 0 8px;">-</span>
                <el-input-number v-model="vdsQueryParam.debtDaysMax" :min="0" placeholder="最大" style="width: 130px;"></el-input-number>
              </el-form-item>
            </el-form>
          </template>
        </div>

        <div style="margin-top: 20px; display: flex; justify-content: space-between; align-items: center;">
          <span style="color: #606266;">
            共 {{ vdsSaleOutList.length }} 条数据，已勾选 {{ vdsSelectedRows.length }} 条
          </span>
        </div>

        <div style="overflow-x: auto;">
          <el-table ref="vdsSaleOutTable" :data="vdsSaleOutList" border style="margin-top: 10px; width: 2400px;" height="600" @selection-change="vdsHandleSelectionChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="organName" label="客户名称" width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="number" label="单据编号" width="180"></el-table-column>
          <el-table-column prop="materialsList" label="商品信息" width="180" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.materialsList ? scope.row.materialsList.replace(',', '，') : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="operTimeStr" label="单据日期" width="150"></el-table-column>
          <el-table-column prop="userName" label="操作人" width="80"></el-table-column>
          <el-table-column prop="contractCode" label="合同编号" width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="salesManStr" label="销售员" width="80"></el-table-column>
          <el-table-column prop="materialCount" label="数量" width="60"></el-table-column>
          <el-table-column prop="totalPrice" label="总金额" width="80">
            <template slot-scope="scope">
              {{ scope.row.totalPrice ? scope.row.totalPrice.toLocaleString() : '0' }}
            </template>
          </el-table-column>
          <el-table-column prop="totalTaxLastMoney" label="税额合计" width="80">
            <template slot-scope="scope">
              {{ (scope.row.discountMoney + scope.row.discountLastMoney) ? (scope.row.discountMoney + scope.row.discountLastMoney).toLocaleString() : '0' }}
            </template>
          </el-table-column>
          <el-table-column prop="needOutMoney" label="应收金额" width="80">
            <template slot-scope="scope">
              {{ (scope.row.discountLastMoney + scope.row.otherMoney - scope.row.deposit) ? (scope.row.discountLastMoney + scope.row.otherMoney - scope.row.deposit).toLocaleString() : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="changeAmount" label="收款" width="60">
            <template slot-scope="scope">
              {{ scope.row.changeAmount ? scope.row.changeAmount.toLocaleString() : '0' }}
            </template>
          </el-table-column>
          <el-table-column prop="collectOutstandingDebts" label="收欠款" width="65"></el-table-column>
          <el-table-column prop="debt" label="欠款" width="60">
            <template slot-scope="scope">
              <span v-if="scope.row.debt > 0 && scope.row.hasFinancialFlag" style="color:green">{{ scope.row.debt ? scope.row.debt.toLocaleString() : '' }}</span>
              <span v-if="scope.row.debt > 0 && !scope.row.hasFinancialFlag" style="color:red">{{ scope.row.debt ? scope.row.debt.toLocaleString() : '' }}</span>
              <span v-if="scope.row.debt === 0">0</span>
            </template>
          </el-table-column>
          <el-table-column prop="outstandingBalance" label="欠款余额" width="75"></el-table-column>
          <el-table-column prop="debtDays" label="欠款天数" width="75"></el-table-column>
          <el-table-column prop="outstandingBalance" label="欠款状态" width="85" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.outstandingBalance <= 0" color="green">无欠款</el-tag>
              <el-tag v-if="scope.row.outstandingBalance > 0" color="red">有欠款</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="80" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status == '0'" color="red">未审核</el-tag>
              <el-tag v-if="scope.row.status == '1'" color="green">已审核</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="materialCount" label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="vdsShowDetail(scope.row)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        </div>

        <div style="margin-top: 20px; text-align: right;">
          <el-button @click="vdsDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="vdsConfirmSync" :disabled="vdsSelectedRows.length === 0" :loading="vdsSyncLoading">确认同步</el-button>
        </div>
      </div>
    </el-dialog>
    <CustomerSelectModal
      ref="vdsCustomerSelectModalForm"
      @ok="vdsCustomerSelectModalFormOk"
    ></CustomerSelectModal>
    <VdsBillDetail
      ref="vdsBillDetailForm"
    ></VdsBillDetail>
    <el-dialog
      title="同步完成"
      :visible.sync="vdsSyncSuccessVisible"
      width="500px"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div style="text-align: center;">
        <i class="el-icon-circle-check" style="font-size: 80px; color: #67C23A;"></i>
        <h3 style="margin: 20px 0;">同步完成</h3>
        <div style="margin: 20px 0; padding: 15px; background-color: #f5f7fa; border-radius: 4px;">
          <div style="display: flex; justify-content: space-around; align-items: center;">
            <div style="text-align: center;">
              <div style="font-size: 24px; font-weight: bold; color: #409EFF;">
                {{ vdsSyncResult.successCount + vdsSyncResult.failCount }}
              </div>
              <div style="font-size: 14px; color: #909399;">总计</div>
            </div>
            <div style="text-align: center;">
              <el-tooltip 
                :content="vdsSyncResult.successNumbers.join(', ')" 
                placement="top" 
                :disabled="vdsSyncResult.successNumbers.length === 0"
              >
                <div style="font-size: 24px; font-weight: bold; color: #67C23A; cursor: pointer;">
                  {{ vdsSyncResult.successCount }}
                </div>
              </el-tooltip>
              <div style="font-size: 14px; color: #909399;">成功</div>
            </div>
            <div style="text-align: center;">
              <el-tooltip 
                :content="vdsSyncResult.failNumbers.join(', ')" 
                placement="top" 
                :disabled="vdsSyncResult.failNumbers.length === 0"
              >
                <div style="font-size: 24px; font-weight: bold; color: #F56C6C; cursor: pointer;">
                  {{ vdsSyncResult.failCount }}
                </div>
              </el-tooltip>
              <div style="font-size: 14px; color: #909399;">失败</div>
            </div>
          </div>
          <div v-if="vdsSyncResult.failNumbers.length > 0" style="margin-top: 15px; padding: 10px; background-color: #fef0f0; border-radius: 4px; border: 1px solid #fde2e2;">
            <div style="font-size: 14px; color: #F56C6C; margin-bottom: 8px;">失败单号：</div>
            <div style="font-size: 13px; color: #606266; word-wrap: break-word;">
              {{ vdsSyncResult.failNumbers.join('、') }}
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="vdsContinueSync">继续同步</el-button>
        <el-button type="primary" @click="vdsBackToDelivery">返回发货列表</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import md5 from "md5"
import editTable from "./components/editTable.vue"
import passTable from "./components/passTable.vue"
import notPassTable from "./components/notPassTable.vue"
import allTable from "./components/allTable.vue"
import pendingReview from "./components/pendingReview.vue"
import {
  addInvoice,
  vdsLogin,
  vdsSearchSaleOut,
  vdsSync,
  vdsGetDepotList,
  vdsGetUserList,
  vdsGetAccountList,
  vdsGetSalesManList,
  // vdsGetCustomerList
}
  from "@/api/invoice"
import CustomerSelectModal from "./components/CustomerSelectModal.vue"
import VdsBillDetail from "./components/VdsBillDetail.vue"
import {
  exportData
} from "@/api/logisticsInformation"

export default {
  components: {
    editTable,
    passTable,
    pendingReview,
    notPassTable,
    allTable,
    CustomerSelectModal,
    VdsBillDetail
  },
  data() {
    return {
      noPassTotal: 0,
      checkAllFreight: false,
      checkedFreight: ['免运费'],
      freightList: ['免运费', '用户自费'],
      isIndeterminateFreight: true,
      dialogAddVisible: false,
      dateRange: null,
      addRuleForm: {
        deliveryNotice: '',
        entryDate: '',
        orderNum: '',
        unitName: '',
        totalAmount: '',
        totalNum: 1,
        invoiceDetails: [],
      },
      isFree: 0,
      addRules: {
        deliveryNotice: [{
          required: true,
          message: '请输入提货通知单编号',
          trigger: 'blur'
        }],
        entryDate: [{
          type: 'date',
          required: true,
          message: '请选择录入日期',
          trigger: 'change'
        }],
        orderNum: [{
          required: true,
          message: '请输入提货单编号',
          trigger: 'blur'
        }],
        unitName: [{
          required: true,
          message: '请输入单位简称',
          trigger: 'blur'
        }],
        totalAmount: [{
          required: true,
          message: '请输入提货金额',
          trigger: 'blur'
        }, {
          type: 'number',
          message: '必须为数字值',
          trigger: 'blur'
        },],
        totalNum: [{
          required: true,
          message: '请输入提货件数',
          trigger: 'blur'
        }, {
          type: 'number',
          message: '必须为数字值',
          trigger: 'blur'
        }],
        nonull: [{
          required: true,
          trigger: 'blur'
        }],
      },
      // pendingLoading: false,
      loading: true,
      loadingUpload: null,
      loadingUploadDetail: null,
      checkAll: true,
      headers: {
        token: localStorage.getItem('token')
      },
      tHeaderBox: [{
        key: 'sparePartsTypeName',
        lable: '备品类型'
      }, {
        key: 'orderNum',
        lable: '提货单编号'
      }, {
        key: 'orderEntryDate',
        lable: '导入日期'
      }, {
        key: 'unitName',
        lable: '单位简称'
      }, {
        key: 'region',
        lable: '地区'
      }, {
        key: 'notPassReason',
        lable: '不通过原因'
      }, {
        key: 'totalAmount',
        lable: '提货金额'
      }, {
        key: 'address',
        lable: '收货人地址'
      }, {
        key: 'receiver',
        lable: '收货人姓名'
      }, {
        key: 'receiverPhone',
        lable: '收货人电话'
      }, {
        key: 'num',
        lable: '发货件数'
      }, {
        key: 'logisticsCompanyName',
        lable: '发货物流'
      }, {
        key: 'trackingNumber',
        lable: '运单号'
      }, {
        key: 'logisticsCompanyPhone',
        lable: '物流电话'
      }, {
        key: 'deliveryDate',
        lable: '发出时间'
      }, {
        key: 'freight',
        lable: '运费'
      }, {
        key: 'isFree',
        lable: '是否免费'
      }, {
        key: 'consignorName',
        lable: '发货人'
      }, {
        key: 'weight',
        lable: '重量'
      }, {
        key: 'volume',
        lable: '体积'
      }, {
        key: 'billingMethod',
        lable: '计费方式'
      }, {
        key: 'remark',
        lable: '备注'
      }, {
        key: 'remark2',
        lable: '备注2'
      }, {
        key: 'isVisit',
        lable: '是否送货上门'
      }, {
        key: 'status',
        lable: '状态'
      }, {
        key: 'entryDate',
        lable: '录入日期'
      }],
      isIndeterminate: false,
      searchInput: '',
      searchValue: '',
      activeName: '-1',
      dialogFormVisible: false,
      dialogFormVisibleDetail: false,
      dialogExportVisible: false,
      ruleForm: {
        date: '',
        fileList: []
      },
      ruleFormDetail: {
        fileList: []
      },
      checkedHeaders: [],
      rules: {
        date: [{
          required: true,
          message: '请选择日期',
          trigger: 'change'
        }],
        fileList: [{
          required: true,
          message: '请导入数据',
          trigger: 'change'
        }]
      },
      rulesDetail: {
        fileList: [{
          required: true,
          message: '请导入数据',
          trigger: 'change'
        }]
      },
      succFiles: [],
      succFilesDetail: [],
      downloadLoading: false,
      sparePartsTypes: [],
      refresh: '0',
      query: {
        status: 0,
        keyword: '',
        page: 1,
        pagesize: 1000000,
        sort: '-entry_date,-unit_name,+order_num',
        sparePartsTypes: [],
        startDate: null,
        endDate: null
      },
      vdsDialogVisible: false,
      vdsIsLoggedIn: false,
      vdsToken: '',
      vdsLoginForm: {
        loginName: '',
        password: ''
      },
      vdsLoginRules: {
        loginName: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      vdsLoginLoading: false,
      vdsSearchLoading: false,
      vdsSyncLoading: false,
      vdsSyncSuccessVisible: false,
      vdsSyncResult: {
        successCount: 0,
        failCount: 0,
        successNumbers: [],
        failNumbers: []
      },
      vdsToggleSearchStatus: false,
      vdsQueryParam: {
        number: '',
        materialParam: '',
        type: '出库',
        subType: '销售',
        createTimeRange: [],
        beginTime: '',
        endTime: '',
        organId: '',
        customerName: '',
        depotId: '',
        creator: '',
        linkNumber: '',
        accountId: '',
        hasDebt: '',
        status: '',
        remark: '',
        salesMan: '',
        contractCode: '',
        debtDaysMin: undefined,
        debtDaysMax: undefined
      },
      vdsSaleOutList: [],
      vdsSelectedRows: [],
      vdsDepotList: [],
      vdsUserList: [],
      vdsAccountList: [],
      vdsSalesManList: []
    }
  },
  mounted() {
    this.handleCheckAllChange(true)
    if (this.common.canAudit()) {
      this.activeName = '1'
    }
  },
  methods: {
    getTotal(data) {
      this.noPassTotal = data
    },
    searchChange() {
      this.loading = false
    },
    CheckedFreightChange(value) {
      this.loading = true
      let checkedCount = value.length;
      if (checkedCount == 0) {
        this.isFree = 0
      } else if (checkedCount == 1) {
        this.isFree = value[0] == '免运费' ? 1 : 2
      } else if (checkedCount == 2) {
        this.isFree = 4
      }
      // this.checkAllFreight = checkedCount === this.freightList.length;
      // this.isIndeterminateFreight = checkedCount > 0 && checkedCount < this.freightList.length;
    },
    detailsAdd() {
      this.addRuleForm.invoiceDetails.push({
        sparePartCode: '',
        sparePartName: '',
        num: 1,
        costPrice: '',
        amount: ''
      })
    },
    detailsDel(row, index) {
      this.addRuleForm.invoiceDetails.splice(index, 1);
    },
    addSubmitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addInvoice(this.addRuleForm).then(res => {
            if (res.code == 0) {
              this.$message({
                type: "success",
                message: "提交成功!",
              });
              this.dialogAddVisible = false
              this.refresh = '0'
              this.activeName = '-1'
              this.searchInput = res.data.orderNum
              this.search()
            }

          })

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    addClick() {
      this.addRuleForm = {
        deliveryNotice: '',
        entryDate: '',
        orderNum: '',
        unitName: '',
        totalAmount: '',
        totalNum: 1,
        invoiceDetails: []
      }
      this.dialogAddVisible = true

    },
    handleCheckAllChange(val) {
      this.checkedHeaders = val ? this.tHeaderBox.map(e => e.key) : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.tHeaderBox.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.tHeaderBox.length;
    },
    exportExcel() {
      this.dialogExportVisible = true
    },
    handleDownload() {
      const loading = this.$loading({
        lock: true,
        text: '正在导出Excel表格，请耐心等待！',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      if (this.activeName == '1') {
        this.query.status = 1
        this.query.sparePartsTypes = this.sparePartsTypes
      } else if (this.activeName == "2") {
        this.query.status = 2
        this.query.sparePartsTypes = []
      } else if (this.activeName == "3") {
        this.query.status = 3
        this.query.sparePartsTypes = []
      } else if (this.activeName == "0") {
        this.query.status = 0
        this.query.sparePartsTypes = []
      }
      this.query.keyword = this.searchInput

      this.downloadLoading = true
      let tHeader = []
      for (let i in this.checkedHeaders) {
        for (let j in this.tHeaderBox) {
          if (this.tHeaderBox[j].key === this.checkedHeaders[i]) {
            tHeader.push(this.tHeaderBox[j].lable)
          }
        }
      }
      if (this.dateRange != null) {
        this.query.startDate = this.dateRange[0]
        this.query.endDate = this.dateRange[1]
      }

      exportData(this.query).then(response => {
        import('@/vendor/Export2Excel').then(excel => {
          let list = response.data
          const data = this.formatJson(this.checkedHeaders, list)
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: '物流明细单',
            autoWidth: true,
            bookType: 'xlsx'
          })
          this.downloadLoading = false
          loading.close();
          this.dialogExportVisible = false
        })
      })

    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {

        if (j === "isVisit") {
          return v[j] === 1 ? "是" : "否"
        }
        if (j === "isFree") {
          return v[j] === 1 ? "是" : "否"
        }

        if (j === 'status') {
          let text = ''
          switch (v[j]) {
            case -1:
              text = '未提交'
              break
            case 1:
              text = '待审核'
              break
            case 2:
              text = '已通过'
              break
            case 3:
              text = '未通过'
              break
          }
          return text
        }

        if (j === 'billingMethod') {
          let text = ''
          switch (v[j]) {
            case 1:
              text = '重量'
              break
            case 2:
              text = '体积'
              break
            case 3:
              text = '发货件数'
              break
            case 4:
              text = '重抛'
              break
            case 5:
              text = '整车'
              break
          }
          return text
        }

        return v[j]
      }))
    },
    appendTracking(orderNum) {
      this.searchInput = orderNum
      this.activeName = "-1"
      this.search()
    },
    sparePartsType(sparePartsTypes) {
      this.sparePartsTypes = sparePartsTypes
    },
    search() {
      this.searchValue = this.searchInput
    },
    fileChange(uploadFile, fileList) {
      this.ruleForm.fileList = uploadFile
      if (fileList.length !== 0) {
        this.$refs.ruleForm.validateField('fileList')
      }
    },
    fileRemove(uploadFile, fileList) {
      if (fileList.length === 0) {
        this.ruleForm.fileList = null
        this.$refs.ruleForm.validateField('fileList')
      }
    },
    handleSuccess(res, file, fileList) {
      if (res.code == 0) {
        this.$message.success('[' + file.name + '] 导入成功')
        this.loadingUpload.close();
        location.reload()
        this.succFiles.push(file)
      } else {
        this.loadingUpload.close();
        this.$message.error('[' + file.name + ']' + res.desc)
      }
      if (this.succFiles.length == fileList.length) {
        this.dialogFormVisible = false
      }
    },
    fileChangeDetail(uploadFile, fileList) {
      this.ruleFormDetail.fileList = uploadFile
      if (fileList.length !== 0) {
        this.$refs.ruleFormDetail.validateField('fileList')
      }
    },
    fileRemoveDetail(uploadFile, fileList) {
      if (fileList.length === 0) {
        this.ruleFormDetail.fileList = null
        this.$refs.ruleFormDetail.validateField('fileList')
      }
    },
    handleSuccessDetail(res, file, fileList) {
      if (res.code == 0) {
        this.$message.success('[' + file.name + '] 导入成功')
        this.addRuleForm.invoiceDetails = res.data
        this.loadingUploadDetail.close();
        //显示明细
        this.succFilesDetail.push(file)
      } else {
        this.loadingUploadDetail.close();
        this.ruleFormDetail.fileList = []
        this.$message.error('[' + file.name + ']' + '文件格式格式错误，请检查文件内同或打开文件重新保存后再导入！')
      }
      if (this.succFilesDetail.length == fileList.length) {
        this.dialogFormVisibleDetail = false
      }
    },
    submitForm(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          this.loadingUpload = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          this.succFiles = []
          this.$refs.upload.submit()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    submitFormDetail(ruleFormDetail) {
      this.$refs[ruleFormDetail].validate((valid) => {
        if (valid) {
          this.loadingUploadDetail = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          this.succFilesDetail = []
          this.$refs.uploadDetail.submit()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    importClick() {
      this.loading = false
      this.ruleForm.date = this.common.today()
      this.ruleForm.fileList = []
      this.dialogFormVisible = true
    },
    importClickDetail() {
      this.ruleFormDetail.fileList = []
      this.dialogFormVisibleDetail = true
    },
    handleClick(tab) {
      console.log(tab)
      this.refresh = this.activeName
    },
    vdsSyncClick() {
      this.vdsDialogVisible = true
      this.vdsIsLoggedIn = false
      this.vdsToken = ''
      this.vdsLoginForm = {
        loginName: '',
        password: ''
      }
      this.$nextTick(() => {
        if (this.$refs.vdsLoginForm) {
          this.$refs.vdsLoginForm.resetFields()
        }
        this.vdsLoginForm = {
          loginName: '',
          password: ''
        }
      })
      this.vdsQueryParam = {
        number: '',
        materialParam: '',
        type: '出库',
        subType: '销售',
        createTimeRange: [],
        beginTime: '',
        endTime: '',
        organId: '',
        customerName: '',
        depotId: '',
        creator: '',
        linkNumber: '',
        accountId: '',
        hasDebt: '',
        status: '',
        remark: '',
        salesMan: '',
        contractCode: '',
        debtDaysMin: undefined,
        debtDaysMax: undefined
      }
      this.vdsSaleOutList = []
      this.vdsSelectedRows = []
      this.vdsDepotList = []
      this.vdsUserList = []
      this.vdsAccountList = []
      this.vdsSalesManList = []
    },
    vdsGetErpData() {
      const tokenParams = { token: this.vdsToken }
      Promise.all([
        vdsGetDepotList(tokenParams),
        vdsGetUserList(tokenParams),
        vdsGetAccountList(tokenParams),
        vdsGetSalesManList(tokenParams)
      ]).then(([depotRes, userRes, accountRes, salesManRes]) => {
        if (depotRes.code == 0) {
          this.vdsDepotList = depotRes.data || []
        }
        if (userRes.code == 0) {
          this.vdsUserList = userRes.data || []
        }
        if (accountRes.code == 0 && accountRes.data && accountRes.data.code == 200) {
          this.vdsAccountList = accountRes.data.data.accountList || []
        }
        if (salesManRes.code == 0) {
          this.vdsSalesManList = salesManRes.data || []
        }
      }).catch(() => {
      })
    },
    vdsHandleLogin() {
      this.$refs.vdsLoginForm.validate((valid) => {
        if (valid) {
          this.vdsLoginLoading = true
          const loginParams = {
            phone: this.vdsLoginForm.loginName,
            password: md5(this.vdsLoginForm.password)
          }
          vdsLogin(loginParams).then(res => {
            if (res.code == 0) {
              this.vdsToken = res.data.data.token
              this.vdsIsLoggedIn = true
              this.$message.success('登录成功')
              this.vdsGetErpData()
            }
          }).catch(() => {
          }).finally(() => {
            this.vdsLoginLoading = false
          })
        }
      })
    },
    vdsSearchSaleOut() {
      this.vdsSearchLoading = true
      const params = {
        token: this.vdsToken,
        search: JSON.stringify(this.vdsQueryParam),
        currentPage: 1,
        pageSize: 1000
      }
      vdsSearchSaleOut(params).then(res => {
        if (res.code == 0) {
          this.vdsSaleOutList = res.data || []
          this.$message.success('查询成功，共 ' + this.vdsSaleOutList.length + ' 条记录')
        }
      }).catch(() => {
      }).finally(() => {
        this.vdsSearchLoading = false
      })
    },
    vdsToggleSearch() {
      this.vdsToggleSearchStatus = !this.vdsToggleSearchStatus
    },
    vdsResetSearch() {
      this.vdsQueryParam = {
        number: '',
        materialParam: '',
        type: '出库',
        subType: '销售',
        createTimeRange: [],
        beginTime: '',
        endTime: '',
        organId: '',
        customerName: '',
        depotId: '',
        creator: '',
        linkNumber: '',
        accountId: '',
        hasDebt: '',
        status: '',
        remark: '',
        salesMan: '',
        contractCode: '',
        debtDaysMin: undefined,
        debtDaysMax: undefined
      }
      this.vdsToggleSearchStatus = false
      this.vdsSaleOutList = []
      this.vdsSelectedRows = []
    },
    vdsOnSearchCustomer() {
      this.$refs.vdsCustomerSelectModalForm.show(this.vdsToken)
    },
    vdsOnClearCustomer() {
      this.vdsQueryParam.organId = ''
      this.vdsQueryParam.customerName = ''
    },
    vdsOnDateChange(value) {
      if (value && value.length === 2) {
        this.vdsQueryParam.beginTime = value[0]
        this.vdsQueryParam.endTime = value[1]
      } else {
        this.vdsQueryParam.beginTime = ''
        this.vdsQueryParam.endTime = ''
      }
    },
    vdsCustomerSelectModalFormOk(customer) {
      this.vdsQueryParam.organId = customer.id
      this.vdsQueryParam.customerName = customer.supplier
    },
    vdsHandleSelectionChange(selection) {
      this.vdsSelectedRows = selection
    },
    vdsConfirmSync() {
      this.$confirm('确认同步选中的 ' + this.vdsSelectedRows.length + ' 条销售出库单数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true
            instance.confirmButtonText = '同步中...'
            const syncData = {
              token: this.vdsToken,
              list: this.vdsSelectedRows
            }
            vdsSync(syncData).then(res => {
              if (res.code == 0) {
                this.vdsSyncResult = {
                  successCount: res.data.successCount || 0,
                  failCount: res.data.failCount || 0,
                  successNumbers: res.data.successNumbers || [],
                  failNumbers: res.data.failNumbers || []
                }
                this.vdsSyncSuccessVisible = true
                done()
              }
            }).catch(() => {
              done()
            }).finally(() => {
              instance.confirmButtonLoading = false
            })
          } else {
            done()
          }
        }
      }).catch(() => {
      })
    },
    vdsContinueSync() {
      this.vdsSyncSuccessVisible = false
      this.vdsSelectedRows = []
      this.$refs.vdsSaleOutTable.clearSelection()
      this.vdsSyncResult = {
        successCount: 0,
        failCount: 0,
        successNumbers: [],
        failNumbers: []
      }
    },
    vdsShowDetail(row) {
      this.$refs.vdsBillDetailForm.show(row, this.vdsToken)
    },
    vdsBackToDelivery() {
      this.vdsSyncSuccessVisible = false
      this.vdsDialogVisible = false
      this.refresh = '0'
    }
  }
}
</script>

<style lang="scss">
@import "~@/assets/css/homepage.scss";
</style>
<style>
.vds-sync-dialog {
  margin-top: 5vh !important;
}
.vds-sync-dialog .el-dialog__body {
  padding: 20px;
  max-height: 80vh;
  overflow-y: auto;
}
</style>
<style lang="scss" scoped>
::v-deep.main-tabs{
	.el-tabs__content{
		overflow: inherit;
	}
}
::v-deep.el-badge {
  height: 20px !important;
  line-height: 20px !important;
  margin-top: -5px !important;

  .el-badge__content {
    right: 15px;
  }
}
</style>
